import { render, staticRenderFns } from "./MemberPerformanceDetail.vue?vue&type=template&id=5f3aae20&scoped=true&"
import script from "./MemberPerformanceDetail.vue?vue&type=script&lang=js&"
export * from "./MemberPerformanceDetail.vue?vue&type=script&lang=js&"
import style0 from "./MemberPerformanceDetail.vue?vue&type=style&index=0&id=5f3aae20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3aae20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VDataTable})
